var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 54,
    viewBox: "0 0 121 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5316 21.1515L0 20.9919C0.942587 27.6922 8.4571 29.2609 12.0965 29.2078C19.3859 28.6334 21.3129 33.1162 21.3653 35.4294C21.6167 25.9852 16.9142 21.9757 14.5316 21.1515Z",
    fill: "url(#paint0_linear_269_692)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7617 35.4292C30.5096 26.0646 34.3756 22.5371 37.615 21.2716L43.3557 16.3678L49.5 8.6167C48.7026 14.1532 52.1783 21.2716 40.0569 29.2599C37.3747 31.0276 30.8142 33.1355 30.7617 35.4292Z",
    fill: "url(#paint1_linear_269_692)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2587 34.9248C21.3847 26.1408 16.6387 22.1016 14.25 21.18C20.235 21.4328 24.7237 23.4971 26.22 24.4977C29.433 21.7803 35.3287 21.1537 37.875 21.18C31.953 23.3918 30.7875 31.2648 30.945 34.9248V43.3771C30.819 49.6965 24.435 52.9616 21.2587 53.8042V34.9248Z",
    fill: "url(#paint2_linear_269_692)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6875,
    cy: 16.1169,
    r: 5.0625,
    fill: "#1772F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35.8196V51.8818H46.6134V48.4677H39.3976V45.4439H46.3545V42.29H39.3976V39.2661H46.6134V35.8196H36Z",
    fill: "url(#paint3_linear_269_692)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0535 35.8196L48.229 51.8818H51.8531L53.018 48.6628H58.6807L59.8779 51.8818H63.502L57.6776 35.8196H54.0535ZM55.8655 40.8268L57.4511 45.2813H54.2476L55.8655 40.8268Z",
    fill: "url(#paint4_linear_269_692)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.001 35.4294C67.6003 35.4294 63.5232 38.6484 63.5232 43.8507C63.5232 49.0855 67.6003 52.3044 72.001 52.3044C74.1043 52.3044 76.1752 51.6216 78.149 50.2235L76.4017 47.6224C74.5249 48.8579 73.2306 48.988 72.001 48.988C69.4771 48.988 66.9855 46.6144 66.9855 43.8507C66.9855 41.087 69.4771 38.7459 72.001 38.7459C73.2306 38.7459 74.5249 38.876 76.4017 40.1115L78.149 37.5104C76.1752 36.1122 74.1043 35.4294 72.001 35.4294Z",
    fill: "url(#paint5_linear_269_692)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7654 35.8196V51.8818H83.163V45.574H88.9874V51.8818H92.385V35.8196H88.9874V42.1599H83.163V35.8196H79.7654Z",
    fill: "url(#paint6_linear_269_692)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6488 35.8196V51.8818H105.262V48.4677H98.0464V45.4439H105.003V42.29H98.0464V39.2661H105.262V35.8196H94.6488Z",
    fill: "url(#paint7_linear_269_692)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.981 35.8196H107.51V51.8818H110.907V48.8254H111.587L115.308 51.8818H120L115.826 48.3702C118.317 47.5573 119.935 45.1187 119.935 42.2575C119.935 38.7134 117.476 35.8196 113.981 35.8196ZM110.907 39.3962H113.625C115.211 39.3962 116.441 40.6643 116.441 42.2575C116.441 43.8182 115.179 45.0212 113.625 45.1187H110.907V39.3962Z",
    fill: "url(#paint8_linear_269_692)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6406 10.5183C64.4531 10.5183 61.5 12.8386 61.5 16.5886C61.5 20.3621 64.4531 22.6824 67.6406 22.6824C69.1641 22.6824 70.6641 22.1902 72.0937 21.1824L70.8281 19.3074C69.4687 20.198 68.5312 20.2917 67.6406 20.2917C65.8125 20.2917 64.0078 18.5808 64.0078 16.5886C64.0078 14.5964 65.8125 12.9089 67.6406 12.9089C68.5312 12.9089 69.4687 13.0027 70.8281 13.8933L72.0937 12.0183C70.6641 11.0105 69.1641 10.5183 67.6406 10.5183Z",
    fill: "#3F3F3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4199 10.5183C75.0449 10.5183 72.3261 13.2371 72.3261 16.5886C72.3261 19.9636 75.0449 22.6824 78.4199 22.6824C81.7949 22.6824 84.537 19.9636 84.537 16.5886C84.537 13.2371 81.7949 10.5183 78.4199 10.5183ZM78.4199 12.9089C80.248 12.9089 82.0292 14.5964 82.0292 16.5886C82.0292 18.5808 80.248 20.2917 78.4199 20.2917C76.6152 20.2917 74.8339 18.5808 74.8339 16.5886C74.8339 14.5964 76.6152 12.9089 78.4199 12.9089Z",
    fill: "#3F3F3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0383 10.5183C88.6633 10.5183 85.9446 13.2371 85.9446 16.5886C85.9446 19.9636 88.6633 22.6824 92.0383 22.6824C95.4133 22.6824 98.1555 19.9636 98.1555 16.5886C98.1555 13.2371 95.4133 10.5183 92.0383 10.5183ZM92.0383 12.9089C93.8665 12.9089 95.6477 14.5964 95.6477 16.5886C95.6477 18.5808 93.8665 20.2917 92.0383 20.2917C90.2336 20.2917 88.4524 18.5808 88.4524 16.5886C88.4524 14.5964 90.2336 12.9089 92.0383 12.9089Z",
    fill: "#3F3F3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.563 10.7996V22.3777H107.297V19.9167H102.094V10.7996H99.563Z",
    fill: "#3F3F3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8521 12.1654L50.5645 9.14575L50.136 10.778L59.8521 12.1654Z",
    fill: "#717171"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3125 15.3151V11C37.3125 5.47715 41.7897 1 47.3125 1H109.25C114.773 1 119.25 5.47715 119.25 11V21.0571C119.25 26.5799 114.773 31.0571 109.25 31.0571H54.3618",
    stroke: "#3F3F3F",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_692",
    x1: 9.1542,
    y1: 27.7209,
    x2: 9.1542,
    y2: 35.4294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1670F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_269_692",
    x1: 41.47,
    y1: 21.1134,
    x2: 41.47,
    y2: 35.4292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1670F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_269_692",
    x1: 24.3678,
    y1: 36.3849,
    x2: 24.3678,
    y2: 53.8042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1670F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_269_692",
    x1: 40.1009,
    y1: 38.0478,
    x2: 113.343,
    y2: 47.3777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1670F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_269_692",
    x1: 40.1009,
    y1: 38.0478,
    x2: 113.343,
    y2: 47.3777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1670F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_269_692",
    x1: 40.1009,
    y1: 38.0478,
    x2: 113.343,
    y2: 47.3777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1670F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_269_692",
    x1: 40.1009,
    y1: 38.0478,
    x2: 113.343,
    y2: 47.3777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1670F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_269_692",
    x1: 40.1009,
    y1: 38.0478,
    x2: 113.343,
    y2: 47.3777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1670F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_269_692",
    x1: 40.1009,
    y1: 38.0478,
    x2: 113.343,
    y2: 47.3777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1670F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0a8b9f0e09238a3f13d7412694612bad.svg";
export { ForwardRef as ReactComponent };